<template>
	<div class="socialComBox" v-if="isGetData" v-cloak>
		<router-link :to="{name:'NewListCon',query:{id:dt[0].category}}"><p class="typeBox"><span class="type">{{dt[0].classificationName}}</span><i class="more"></i></p></router-link>
		<div class="swiper-container">
	          <div class="swiper-wrapper">
	            <div v-for='(i,index) in dt' :key='index' class="swiper-slide" ref="swiperS" :aa='index'>
	            	<router-link :to="{name:'NewDetail',query:{detailID:i.id}}">
		              	<div class="iSlide">
		              		{{dt}}
		                  <img class="img" :src="i.cover_img2">
		              		}
		                </div>
		                <div class="slideTxtBox">
		                	<p class="slideTitle">{{i.title}}</p>
		                	<p class="slideTxt">{{i.description}}</p>
		                </div>
		        	</router-link> 		                
	            </div>   
	          </div>
	    </div>
	</div>    
</template>

<script>
import Swiper from 'swiper' 
import '../../../node_modules/swiper/dist/css/swiper.css'
import '../../../node_modules/swiper/dist/css/swiper2.min.css'

export default{
  	name: 'socialSwiper',
  	props:['dt','id'],
  	data(){
	    return {
	       // socialDatas: '',
	       isGetData:false
	    }
    },
  	created(){
  		// console.log(this.dt);
  		// if(this.socialDatas){
  		// 	this.isGetData = true
  		// }
		// this.axios.get(this.$root.baseUrl+'/wap/responsibility/resList?category='+this.id)
		// .then(res=>{
		//   this.socialDatas = res.data;
		//   console.log(this.socialDatas)
		// })
		// .catch(e=>{
		//   console.log(e)
		// })
	},
	mounted:function(){
	  		
	},
	watch:{
		dt:function(){
			if(this.dt){  			
	  			this.isGetData = true
			    var mySwiper = new Swiper('.swiper-container', {
			      loop : true,
			      effect : 'slide'
			  	});
	  		}
		}
	}
}


</script>

<style scoped>
.swiper-slide{
	font-size: 0;
    background: #fff;
}
.socialComBox{
    width: 22.86667rem;
    margin: 0 auto 2.1333rem;
}
.swiper-container{
    width: 22.2rem;
	height: 12.2rem;
	border: 1px solid #ccc;
}
.iSlide{
    height: 11rem;
    width: 11rem;
    margin: 0.6rem;
    display: inline-block;
    vertical-align: top;
}
.iSlide img{
    width: 100%;
	border-radius: 4px;    
}
.typeBox{
    font-size: 1.3333rem;
    height: 3.9666rem;
    line-height: 3.9666rem;
    font-size: 1.333rem;
    color: #333;
    /* box-sizing: border-box; */
    width: 22.2rem;
    margin: 0 auto;
}
.type{
	display: inline-block;
	vertical-align: middle;
    font-weight: bolder;
    font-size: 1.6rem;	
}
.more{
	background: url(../../../static/img/more.png) center center/100% 100% no-repeat;
    height: 0.93333rem;
    width: 0.53333rem;
    display: inline-block;
    vertical-align: middle;
	margin-left: 15.1rem;
}
.slideTxtBox{
    width: 9.86667rem;
    display: inline-block;
    vertical-align: top;
    height: 11rem;
    overflow: hidden;
}
.slideTitle{
    font-size: 0.86667rem;
    font-weight: bold;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    margin: 1.4333rem 0;
}
.slideTxt{
    font-size: 0.8rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
}
a{
	color: #333;
}
[v-cloak]{ display :none }
</style>


// WEBPACK FOOTER //
// src/components/socialResponsibility/socialSwiper.vue